/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

export const SlidePersonalAreaTimeIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M15.8333 3.33333H4.16667C3.24619 3.33333 2.5 4.07952 2.5 5V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V5C17.5 4.07952 16.7538 3.33333 15.8333 3.33333Z" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M13.333 1.66667V5" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6.66699 1.66667V5" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M2.5 8.33333H17.5" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5.83301 11.6667H6.66634" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9.58301 11.6667H10.4163" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M13.333 11.6667H14.1663" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5.83301 14.1667H6.66634" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9.58301 14.1667H10.4163" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M13.333 14.1667H14.1663" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default SlidePersonalAreaTimeIcon;
